import { GrowthBook } from '@growthbook/growthbook'
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins'

// Prefer env vars (CRA exposes only REACT_APP_* to the client). Fallback to current values.
const apiHost =
  process.env.REACT_APP_API_HOST ||
  'https://apim-pfna.dev.mypepsico.com/it/dps/v1/featuretoggle/api/features/'
const clientKey = process.env.REACT_APP_CLIENT_KEY || 'sdk-vj6YHuphVmiD'
export const growthbook = new GrowthBook({
  apiHost,
  clientKey,
  enableDevMode: process.env.REACT_APP_ENABLE_DEV_MODE_FOR_GROWTHBOOK,
  trackingCallback: (experiment, result) => {
    console.log('Viewed experiment', experiment.key, '→ variation', result.variationId)
  },
  plugins: [autoAttributesPlugin()],
})

// Set any user/app attributes needed for targeting
growthbook.setAttributes({
  // id: "user-123",
  // country: "IN",
  // appVersion: "1.0.0",
})

// Prevent multiple inits
let gbInited = false

// Pull features with auth token, similar to PlanningYearContext's approach
const resolveToken = async () => {
  // Prefer session token
  const sessionToken = sessionStorage.getItem('auth_token')
  if (sessionToken) return sessionToken
  // Fallback: try Okta access token if available on window (app may attach it)
  if (window && window.oktaAuth && typeof window.oktaAuth.getAccessToken === 'function') {
    const oktaToken = await window.oktaAuth.getAccessToken()
    if (oktaToken) return oktaToken
  }
  return null
}

export const initGrowthbookWithToken = async (token) => {
  if (gbInited) return
  if (!token) return
  const url = `${apiHost}${clientKey}`
  try {
    const resp = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`)
    const payload = await resp.json()
    await growthbook.init({ payload })
    gbInited = true
  } catch (e) {
    console.error('Failed to load GrowthBook features:', e)
  }
}

const loadGrowthbookFeatures = async () => {
  if (gbInited) return
  const url = `${apiHost}${clientKey}`
  const token = await resolveToken()
  if (!token) return
  try {
    const resp = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`)
    const payload = await resp.json()
    await growthbook.init({ payload })
    gbInited = true
  } catch (e) {
    console.error('Failed to load GrowthBook features:', e)
  }
}

// Initial attempt
loadGrowthbookFeatures()

// No listeners needed; single attempt on module load is sufficient

export default growthbook
